import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SIGN_FORM_GDPR_RADIO_REMOVAL_EXPERIMENT = defineFcm('sign_form_gdpr_radio_removal_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'petition page',
		description: 'Gates the sign form GDPR radio removal experiment on the petition details page.',
		import: false,
		template: { enabled: true },
	});
